export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Cn-a844ca1fdc63222e8736f12a75bdd0fc.woff";